import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { IPaymentSummariesFormValues, IPaymentSummaryFile } from 'features/PaymentsSummary/types'
import { paymentSummaryCategoryMessages } from 'features/PaymentsSummary/constants'
import { CircleIcon } from 'components/Icons/CircleIcon'
import { FilledDownloadIcon } from 'components/Icons/FilledDownloadIcon'
import { FilledCircleCheckIcon } from 'components/Icons/FilledCircleCheckIcon'

const FilesStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const FileStatusItem = styled.div`
  display: flex;
  gap: 8px;
`

const FileStatusItemLabel = styled.div`
  color: #423f9a;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.41px;
`

export const PaymentSummaryFilesStatus = (): ReactElement => {
  const intl = useIntl()
  const { values } = useFormikContext<IPaymentSummariesFormValues>()

  return (
    <FilesStatusContainer>
      {values.files.map((file) => (
        <FileStatusItem key={file.category}>
          <FileStatus file={file} />
          <FileStatusItemLabel>{intl.formatMessage(paymentSummaryCategoryMessages[file.category])}</FileStatusItemLabel>
        </FileStatusItem>
      ))}
    </FilesStatusContainer>
  )
}

interface IFileStatusProps {
  file: IPaymentSummaryFile
}

const FileStatus = ({ file }: IFileStatusProps): ReactElement => {
  const hasSubmittedFile = file.id
  const hasErrors = file.errorPath

  if (hasSubmittedFile && hasErrors) {
    return (
      <a href={file.errorPath} download={file.errorPath}>
        <FilledDownloadIcon />
      </a>
    )
  } else if (hasSubmittedFile) {
    return <FilledCircleCheckIcon />
  }

  return <CircleIcon />
}
